import { render, staticRenderFns } from "./OwnerPortal.vue?vue&type=template&id=d246d136"
var script = {}
import style0 from "./OwnerPortal.vue?vue&type=style&index=0&id=d246d136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports